import { ValueGetterParams } from 'ag-grid-enterprise';
import { take } from 'rxjs/operators';
import { DocumentReader } from 'src/app/modules/core/store/models';

export const picklistValueGetter = (params: ValueGetterParams) => {
  const field = params.colDef.cellRendererParams.schemaField;
  const picklistService = params.colDef.cellRendererParams.picklistService;

  const reader = new DocumentReader(params.data);
  const selectedItem = reader.getFieldValue(field.systemName);

  let value = '';
  if (!!selectedItem) {
    if (!!picklistService) {
      picklistService
        .getPicklistValues(field)
        .pipe(take(1))
        .subscribe(picklistValues => {
          const selectedPicklistItem = picklistValues?.find(p => p.uId === selectedItem);
          if (!!selectedPicklistItem) {
            value = selectedPicklistItem.value;
          }
        });
    } else {
      const selectedPicklistItem = field.picklistValues?.find(p => p.uId === selectedItem);
      if (!!selectedPicklistItem) {
        value = selectedPicklistItem.value;
      }
    }
  }

  return value;
};
